import request from '@/utils/request'

// 获取家长身份列表
export function parentalIdentity(params) {
	return request.post('/v1/baby/identification', params)
}

// h5获取分享页面详情
export function shareDetailsData(params) {
	return request.post('/v1/share/h5url', params)
}

// h5根据邀请码查询孩子数据
export function invitationChildrenDataList(params) {
	return request.post('/v1/share/query/child', params)
}

// 获取验证码(与登录页面相同)
export function sendVerifyCode(params) {
	return request.post('/v1/auth/mobileLogin', params)
}

// 注册、登录方法（手机号码+验证码 与登录页面相同）
export function phoneCodeLogin(params) {
	return request.post('/v1/auth/login', params);
}

// 绑定孩子和家长
export function bindingOfChildrenAndParents(params) {
	return request.post('/v1/share/h5bind', params);
}
// 绑定好友
export function bindingFriend(params) {
	return request.post('/v1/familyFriendsGroup/oneKeyFamilyFriendsGroup', params);
}